const toValveSettingsMachine = (location, machineNumber, machine) => {
  if (!machine) return null;

  const { gasType, sysIdentification = {}, gasValue = {} } = machine;

  return {
    location,
    machineNumber,
    locationName: machine.locationName || location,
    machineName: machine.machineName || machineNumber,
    gasType,
    tes:
      sysIdentification.isHeatingSysWithTes ??
      sysIdentification.isHeatingSystemWithTes,
    switchSize: sysIdentification.switchSize,
    application: sysIdentification.application,
    startPosition: gasValue.startPosition,
    minPosition: gasValue.minPosition,
    maxPosition: gasValue.maxPosition,
  };
};

export const getValveSettingsSearchResult = (tgs = {}, searchValue = '') => {
  if (typeof searchValue !== 'string') return null;

  const parts = searchValue.split(' - ');
  if (parts.length < 2) return null;

  const machineNumber = parts[parts.length - 1];
  const location = parts[parts.length - 2];

  return toValveSettingsMachine(
    location,
    machineNumber,
    tgs?.[location]?.[machineNumber],
  );
};

export const collectSelectedValveSettingsMachines = (
  tgsSpec = {},
  tgs = {},
) => {
  const selectedMachines = [];

  Object.entries(tgsSpec).forEach(([location, locationData]) => {
    if (locationData.isSpecificLocation) {
      Object.entries(locationData.subLocations || {}).forEach(
        ([specificLocation, specificLocationData]) => {
          Object.entries(specificLocationData.devices || {}).forEach(
            ([machineNumber, machine]) => {
              if (!machine.isSelectedValveSettings) return;

              selectedMachines.push(
                toValveSettingsMachine(
                  specificLocation,
                  machineNumber,
                  tgs?.[specificLocation]?.[machineNumber] || machine,
                ),
              );
            },
          );
        },
      );
      return;
    }

    Object.entries(locationData.devices || {}).forEach(
      ([machineNumber, machine]) => {
        if (!machine.isSelectedValveSettings) return;

        selectedMachines.push(
          toValveSettingsMachine(
            location,
            machineNumber,
            tgs?.[location]?.[machineNumber] || machine,
          ),
        );
      },
    );
  });

  return selectedMachines.filter(Boolean);
};

